import { useEffect, useRef } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
    _fbq_pageview_tracked?: boolean
  }
}

export function useMetaPixel(pixelId: string) {
  const hasTrackedPageView = useRef(false)

  useEffect(() => {
    // Double check: if we've already tracked pageview, don't do anything
    if (hasTrackedPageView.current || window._fbq_pageview_tracked) {
      return
    }

    // Check if pixel is already loaded to prevent duplicate initialization
    if (window.fbq) {
      // Pixel exists but we haven't tracked yet, just track once
      if (!hasTrackedPageView.current && !window._fbq_pageview_tracked) {
        window.fbq('track', 'PageView')
        hasTrackedPageView.current = true
        window._fbq_pageview_tracked = true
      }
      return
    }

    // Initialize Meta Pixel
    ;(function (f: any, b: any, e: any, v: any, n?: any, t?: any) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      // Append to head instead of trying to find existing script
      b.head.appendChild(t)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )

    // Initialize pixel with ID and disable ALL automatic tracking
    window.fbq('init', pixelId, {
      autoConfig: false,
      debug: false,
    })

    // Disable automatic advanced matching
    window.fbq('set', 'autoConfig', false, pixelId)

    // Track PageView event ONCE on initial load only
    if (!hasTrackedPageView.current && !window._fbq_pageview_tracked) {
      window.fbq('track', 'PageView')
      hasTrackedPageView.current = true
      window._fbq_pageview_tracked = true
    }
  }, [pixelId])
}
